import { UserLocale } from '@teetsh/app/src/types/user';
import {
  Planner,
  PlannerCalendarPDFSettings,
} from '@teetsh/app/src/types/planner';
import { format } from '@teetsh/app/src/utils/time/format';
import _isEmpty from 'lodash-es/isEmpty';

interface Props {
  planner: Planner;
  lng: UserLocale;
  date: Date;
  settings: PlannerCalendarPDFSettings;
  selectedCategories?: string[];
}

export function buildPlannerCalendarPDFParams({
  planner,
  lng,
  date,
  settings,
  selectedCategories,
}: Props) {
  const params = new URLSearchParams({
    lng,
    date: format(date, lng),
    fontSize: (settings.fontSize || 14).toString(),
    bgColor: settings.bgColor || 'white',
    marginTop: (settings.marginTop ?? 4).toString(),
    marginRight: (settings.marginRight ?? 4).toString(),
    marginBottom: (settings.marginBottom ?? 4).toString(),
    marginLeft: (settings.marginLeft ?? 4).toString(),
  });

  if (selectedCategories && selectedCategories.length > 0) {
    params.set('selectedCategories', selectedCategories.join(','));
  }

  if (!_isEmpty(planner.title)) {
    params.set('title', planner.title);
  }

  if (settings.font) {
    params.set('font', settings.font);
  }

  return params;
}
